import { Dispatch, SetStateAction } from 'react'
import FormCard from '../../../inputFormComponents/FormCard'
import { DateInput, required, useTranslate } from 'react-admin'
import InvoiceTypeInput from '../InvoiceTypeInput'
import NumberRangeInput from '../NumberRangeInput'
import { InvoiceType, NumberRangeReadModel } from '../../../GeneratedClients/FreeBillApi'
import FormRow from '../../../inputFormComponents/FormRow'

interface IProps {
  setInvoiceType: Dispatch<SetStateAction<InvoiceType>>
  isSmallBusiness?: boolean
  cardNumber?: number
  description?: JSX.Element
  numberRanges?: NumberRangeReadModel[]
  defaultInvoiceDate?: string
  defaultDueDate?: string
}

const InvoiceTypeCard = ({setInvoiceType, isSmallBusiness, cardNumber, description, defaultInvoiceDate, defaultDueDate}: IProps) => {
  
  const translate = useTranslate()

  const rows = [
    <FormRow  fields={[
      <InvoiceTypeInput setInvoiceType={setInvoiceType} isSmallBusiness={isSmallBusiness} />,
    ]} />,
    <FormRow  fields={[
      <DateInput 
        fullWidth 
        helperText={false} 
        source="invoiceDate" 
        label="resources.invoices.invoiceDate" 
        validate={required()} 
        defaultValue={defaultInvoiceDate}
      />,
      <DateInput 
        sx={{ml: 2}} 
        fullWidth 
        helperText={false} 
        source="dueDate" 
        label="resources.invoices.dueDate" 
        defaultValue={defaultDueDate}
      />,
    ]} />,
    <FormRow  fields={[
      <NumberRangeInput />,
    ]} />
  ]

  return (
    <FormCard 
      title={translate('resources.invoices.form.invoiceType')}
      cardNumber={cardNumber}
      description={description}
      rows={rows}
    />
  )
}

export default InvoiceTypeCard